import React, { useState } from 'react';
import { Camera, X } from 'lucide-react';

const PhotoHighlights = ({ photos }) => {
    const [showGalleryModal, setShowGalleryModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const displayPhotos = photos ? photos.slice(0, 4) : [];

    return (
        <>
            <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col h-full">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-sm font-bold text-gray-900">Photo Highlights</h3>
                    <div className="flex items-center text-gray-500 text-[10px] gap-1">
                        <Camera size={12} />
                        {photos?.length || 0} this week
                    </div>
                </div>

                <div className="flex-1 mb-4 min-h-[160px] flex flex-col">
                    {photos?.length > 0 ? (
                        <div className="grid grid-cols-2 gap-3 h-full">
                            {displayPhotos.map((photo) => (
                                <div
                                    key={photo.id}
                                    className="relative aspect-square rounded-lg overflow-hidden bg-gray-200 cursor-pointer transition-transform hover:scale-[1.02]"
                                    onClick={() => setSelectedPhoto(photo)}
                                >
                                    {photo.url ? (
                                        <img src={photo.url} alt={photo.title} className="w-full h-full object-cover" />
                                    ) : (
                                        <div className="w-full h-full bg-gray-300"></div>
                                    )}

                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                                        <p className="text-[10px] font-bold text-white leading-tight truncate mb-0.5">{photo.title}</p>
                                        <p className="text-[8px] text-gray-200">{photo.time}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="aspect-square w-full flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-6 bg-slate-50">
                            <Camera size={32} className="text-gray-400 mb-2 opacity-50" />
                            <p className="text-sm font-medium text-gray-400">No photos uploaded this week</p>
                        </div>
                    )}
                </div>

                {photos && photos.length > 4 && (
                    <button
                        onClick={() => setShowGalleryModal(true)}
                        className="w-full bg-gray-50 hover:bg-gray-100 text-gray-600 font-medium py-2 rounded-lg text-xs transition-colors border border-gray-100"
                    >
                        View All Photos
                    </button>
                )}
            </div>

            {/* Single Photo Modal */}
            {selectedPhoto && (
                <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setSelectedPhoto(null)}>
                    <div className="relative max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden rounded-lg" onClick={(e) => e.stopPropagation()}>
                        <button
                            onClick={() => setSelectedPhoto(null)}
                            className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors z-10"
                        >
                            <X size={20} />
                        </button>
                        {selectedPhoto.url ? (
                            <img src={selectedPhoto.url} alt={selectedPhoto.title} className="w-full h-full object-contain max-h-[85vh]" />
                        ) : (
                            <div className="w-[500px] h-[400px] bg-gray-200 flex items-center justify-center text-gray-500">No Image Available</div>
                        )}
                        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-6 pt-20">
                            <h3 className="text-xl font-bold text-white mb-1">{selectedPhoto.title}</h3>
                            <p className="text-sm text-gray-200">{selectedPhoto.time}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Gallery Modal */}
            {showGalleryModal && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden">
                        <div className="flex justify-between items-center p-4 border-b border-gray-100">
                            <h3 className="text-xl font-bold text-gray-900">Photo Highlights ({photos.length})</h3>
                            <button
                                onClick={() => setShowGalleryModal(false)}
                                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                            >
                                <X size={24} className="text-gray-500" />
                            </button>
                        </div>

                        <div className="p-6 overflow-y-auto">
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                {photos.map((photo) => (
                                    <div
                                        key={photo.id}
                                        className="relative aspect-square flex flex-col group overflow-hidden rounded-xl shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                                        onClick={() => setSelectedPhoto(photo)}
                                    >
                                        {photo.url ? (
                                            <img src={photo.url} alt={photo.title} className="w-full h-full object-cover" />
                                        ) : (
                                            <div className="flex-1 bg-gray-300 w-full h-full"></div>
                                        )}

                                        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 pt-8">
                                            <p className="text-xs font-bold text-white leading-tight truncate mb-0.5">{photo.title}</p>
                                            <p className="text-[10px] text-gray-300">{photo.time}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PhotoHighlights;
